module.exports = __webpack_public_path__ + "img/ab-desktop-hover.6c62730b.png";